import { render } from "./ChainCustomerPricingForm.vue?vue&type=template&id=bd2e5394&scoped=true"
import script from "./ChainCustomerPricingForm.vue?vue&type=script&lang=js"
export * from "./ChainCustomerPricingForm.vue?vue&type=script&lang=js"

import "./ChainCustomerPricingForm.vue?vue&type=style&index=0&id=bd2e5394&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2e5394"]])

export default __exports__